module.exports = __webpack_public_path__ + "img/icon6.4281c7e.png";